// 判断环境
let IS_DEV: boolean;
let IS_LOCAL: boolean;
if ( location.host === 'guanjia.qq.com'
) {
  IS_DEV = false;
} else {
  IS_DEV = true;
}

if (location.host.includes('localhost')){
  IS_LOCAL = true;
}

export  {
  IS_DEV,
  IS_LOCAL
};
